export default __webpack_public_path__ + "static/image4-3c93b56b01604d41372ac03ba844cd8e.gif";